import { Injectable } from '@angular/core';
import { STORAGE_KEYS, LEGACY_STORAGE_KEYS } from '../../../shared/constants';
import { ContextoPWA } from '../../../shared/types';
import { parseJSONSafe } from '../../../shared/utils';
import { MobileContextService } from './mobile-context.service';

@Injectable({
  providedIn: 'root'
})
export class ContextService {

  constructor(private mobileContextService: MobileContextService) {}

  getAppContext(): string | null {
    try {
      // Fallback de leitura na chave antiga (__pwa_bridge_app_context) por 1 release — TODO remover
      const bridgeContext = localStorage.getItem(STORAGE_KEYS.BRIDGE_APP_CONTEXT) ||
        localStorage.getItem(LEGACY_STORAGE_KEYS.BRIDGE_APP_CONTEXT);
      if (bridgeContext) {
        return bridgeContext;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  getUserAccess(): string | null {
    try {
      // Fallback de leitura na chave antiga (__pwa_bridge_user_access) por 1 release — TODO remover
      const bridgeUserAccess = localStorage.getItem(STORAGE_KEYS.BRIDGE_USER_ACCESS) ||
        localStorage.getItem(LEGACY_STORAGE_KEYS.BRIDGE_USER_ACCESS);
      return bridgeUserAccess;
    } catch (error) {
      return null;
    }
  }

  /** Contexto completo salvo, escrito pelo MobileContextService. */
  loadContextoCompleto(): ContextoPWA | null {
    // Fallback de leitura na chave antiga (__pwa_bridge_contexto_completo) por 1 release — TODO remover
    const contextoData = localStorage.getItem(STORAGE_KEYS.BRIDGE_CONTEXTO_COMPLETO) ||
      localStorage.getItem(LEGACY_STORAGE_KEYS.BRIDGE_CONTEXTO_COMPLETO);
    if (contextoData) {
      return parseJSONSafe<ContextoPWA | null>(contextoData, null);
    }

    return null;
  }

  decodeAppContext(appContextBase64: string): { servidor?: number; anoletivo?: { value: number }; estabelecimento?: { value: string }; turma?: { value: string } } | null {
    try {
      return JSON.parse(atob(appContextBase64));
    } catch (error) {
      return null;
    }
  }

  /** `MobileContextService` é a fonte de verdade; storage bruto é só fallback se ainda sem turma. */
  getTurma(): { id: number; nome?: string; descricao?: string } | null {
    const fromMobile = this.mobileContextService.getContextoAtual()?.turma;
    if (fromMobile?.id) {
      return fromMobile;
    }
    const contexto = this.loadContextoCompleto();
    return contexto?.turma || null;
  }

  /**
   * Nada no app hoje popula `contexto.periodo` — sempre `null` até algum fluxo real
   * escrevê-lo. Os consumidores (desempenho-data.service.ts, instrumentos-avaliacao.component.ts)
   * já tratam `null` como "período ainda não resolvido" e substituem quando a API responde.
   */
  getPeriodo(): { id: number; descricao?: string; dataInicial?: string; dataFinal?: string } | null {
    const contexto = this.loadContextoCompleto();
    return contexto?.periodo || null;
  }

  /** Mesma prioridade de `getTurma()`: MobileContextService primeiro, storage bruto como fallback. */
  getComponentes(): Array<{ id: number; descricao?: string; nome?: string }> {
    const fromMobile = this.mobileContextService.getContextoAtual()?.componentes;
    if (fromMobile && fromMobile.length > 0) {
      return fromMobile;
    }
    const contexto = this.loadContextoCompleto();
    if (contexto?.componentes && contexto.componentes.length > 0) {
      return contexto.componentes;
    }
    return [];
  }
}